import { render, staticRenderFns } from "./GeometryDetails.vue?vue&type=template&id=30accb91&"
import script from "./GeometryDetails.vue?vue&type=script&lang=js&"
export * from "./GeometryDetails.vue?vue&type=script&lang=js&"
import style0 from "./GeometryDetails.vue?vue&type=style&index=0&id=30accb91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports